module.exports = __webpack_public_path__ + "img/logo.a8e2b326.png";